export default __webpack_public_path__ + "static/media/3-2-4.8fe79449.jpg";